import React, { useEffect, useRef } from "react";
import styled from "styled-components";

import SoremonCharacter from "./SoremonCharacter";
import { setSoremonPanelOpen, useSoremonMood, useSoremonPanelOpen } from "./soremonStore";
import { useSoremonAvailable } from "./useSoremonAvailable";
import { OVERLAY_HOVER_OPEN_DELAY_MS } from "../global/headerOverlay";

const Trigger = styled.button`
  display: flex;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  border-radius: 50%;

  &:focus-visible {
    outline: 2px solid var(--soremo-blue);
    outline-offset: 2px;
  }
`;

/**
 * GlobalHeader 右端（ユーザーアイコンの反対側）に住む soremon。
 * ホバー（タッチ端末ではタップ）でパネルを開く。閉じるのはパネルの外側クリックか Esc
 * （ユーザーアイコンのポップオーバーと同じ開閉ルール）。
 * パネルを閉じていても処理中の状態（考えている / 実行している 等）を映す。
 */
const SoremonHeaderButton: React.FC = () => {
  const available = useSoremonAvailable();
  const open = useSoremonPanelOpen();
  const mood = useSoremonMood();
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const cancelOpen = () => {
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = null;
  };
  useEffect(() => cancelOpen, []);

  if (!available) return null;

  return (
    <Trigger
      type="button"
      aria-label="soremon を開く"
      aria-expanded={open}
      data-soremon-trigger
      onMouseEnter={() => {
        cancelOpen();
        timerRef.current = setTimeout(() => setSoremonPanelOpen(true), OVERLAY_HOVER_OPEN_DELAY_MS);
      }}
      onMouseLeave={cancelOpen}
      onClick={() => {
        cancelOpen();
        setSoremonPanelOpen(true);
      }}
    >
      <SoremonCharacter mood={mood} size="medium" />
    </Trigger>
  );
};

export default SoremonHeaderButton;
